import React, { useEffect, useState } from "react";
import classNames from "classnames";

import styles from "./index.module.scss";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper/core";

import { SessionStatus } from "../../config/Config";

import "../../../node_modules/swiper/swiper.min.css";
import "../../../node_modules/swiper/components/navigation/navigation.min.css";
import { getLocalValue } from "../../utils/auth";
import { dayJS } from "../../utils/datetime";

import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import { useTranslation } from "react-i18next";

SwiperCore.use([Navigation, Pagination]);

export default function Compliments({
  filter,
  className,
  handleLikeCallback,
  ...props
}) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [compliments, setCompliments] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);

      // const apiAttr = getAttr(props.api )
      const response = await apiRequest.get(
        `/api/getPersonalCompliments?coachee_id=${getLocalValue(
          "uid"
        )}&filter=${filter}`
      );

      if (response && response.status === 200) {
        setCompliments(response.data.data);
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
      }

      setIsLoading(false);
    }

    fetchData();
  }, [filter]);

  const handleLike = index => {
    let newList = JSON.parse(JSON.stringify(compliments));
    const newVal = !newList[index].liked;
    const id = newList[index].note_id;
    newList[index].liked = newVal;
    setCompliments(newList);

    apiRequest
      .patch(`/api/updateNoteLikes/${id}`, { liked_by_coachee: newVal })
      .then(
        setTimeout(function () {
          handleLikeCallback();
        }, 500)
      );
  };

  return (
    <div
      className={classNames(styles.complimentsWrapper, className)}
      {...props}
    >
      {compliments.length > 0 && (
        <Swiper
          slidesPerView={"auto"}
          spaceBetween={24}
          navigation
          pagination={{
            clickable: true,
          }}
          className={styles.swiper}
        >
          {compliments.map((item, index) => {
            return (
              <SwiperSlide
                key={index}
                className={`${styles.complimentItem} ${
                  item.status === SessionStatus.ARCHIVED && styles.disabled
                }`}
              >
                <div className={styles.topBar}>
                  <div className={styles.icon}>
                    <EmojiEventsIcon />
                  </div>
                  <div className={styles.noteType}>Compliments</div>
                  <div className={styles.fromUsername}>
                    by {item.from_username}
                  </div>
                </div>
                <div
                  className={`${styles.likeButton} ${
                    item.status !== SessionStatus.ARCHIVED && styles.clickable
                  } ${item.liked && styles.liked}`}
                  onClick={() => {
                    if (item.status !== SessionStatus.ARCHIVED)
                      handleLike(index);
                  }}
                >
                  <ThumbUpIcon />
                </div>

                <div className={styles.textContent} title={item.text}>
                  {item.text}
                </div>
                <div className={styles.date}>
                  {dayJS(item.datetime).format("DD MMM YYYY")}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
      {compliments.length === 0 && (
        <div className={styles.noData}>{t("dashboard.noDataYet")}</div>
      )}
    </div>
  );
}
